import styled from "styled-components";
import trianglify from "trianglify";
const symbols = /[\r\n%#()<>?\[\\\]^`{|}]/g;


function getTriangle() {
  const map = [
    ["#6CC2BD", "#005b34", "#9DCFC2"],
    ["#d42128", "#ffb717", "#6d1e6a"],
    ["#F67E7D", "#5A819E", "#7D7AA2"],
  ];
  if (typeof window === "undefined") {
    return "#6CC2BD";
  }
  const pattern = trianglify({
    height: 1000,
    width: 1500,
    variance: 0.7,
    cellSize: 150,
    xColors: map[Math.floor(Math.random() * map.length)],
  });

  // eslint-disable-next-line immutable/no-let
  let data = pattern.toSVGTree().toString();

  data = data.replace(/"/g, '\'');
  data = data.replace(/>\s{1,}</g, "><");
  data = data.replace(/\s{2,}/g, " ");
  data = data.replace(symbols, encodeURIComponent);

  return `url("data:image/svg+xml,${data}")!important`;
}

const Triangle = styled.section`
  width: 100%;
  position: relative;
  color: white;
  background-image: ${() => getTriangle()};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export { Triangle };